import Vue from 'vue'

const defCurrencyFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
})

Vue.filter('fmtcurrency', value => {
  return defCurrencyFormatter.format(value)
})